import React, { useState, useEffect } from "react";
import axios from "axios";
import ProductTable from "../../Utills/Table/ProductTable";
import Switch from "@mui/material/Switch";
import ProductModal from "../../components/Modal/Product/AddProductModal";
const ProductPage = ({ check, change }) => {
  const [loading, setLoading] = useState(true);
  const [product, setProduct] = useState([]);

  useEffect(() => {
    if (loading) {
      axios
        .get("https://tsetsegtuw.templateapi.xyz/product")
        .then((e) => setProduct(e.data.data))
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [loading]);
  if (loading) {
    return (
      <div className="loader-container">
        <div>loader</div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-start min-h-screen ml-[18vw] w-[80vw] p-6">

      <div className="w-full flex justify-end mb-4 items-center">
        <Switch
          checked={check}
          onChange={change}
          inputProps={{ "aria-label": "controlled" }}
        />
        <ProductModal />
      </div>
      <div className="w-full max-w-7xl">
        <ProductTable products={product} />
      </div>
    </div>
  );
};

export default ProductPage;